import { css } from "@emotion/react";
import { FONTS, fontSize } from "../../../../styles/fonts";

export const sharedInputStyles = [
  FONTS.MinervaModern500,
  fontSize.x2,
  css`
    height: calc(var(--h) - 2 * var(--b) - 2 * var(--c));
    border: none;
    width: 100%;

    padding-top: 20px;
    padding-bottom: 20px;
    padding-right: 20px;

    border-radius: 6px;

    &:focus,
    &.focus-visible {
      outline: none !important;
    }
  `,
];
